import { render, staticRenderFns } from "./topicStat.vue?vue&type=template&id=64f83016&scoped=true&"
import script from "./topicStat.vue?vue&type=script&lang=js&"
export * from "./topicStat.vue?vue&type=script&lang=js&"
import style0 from "./topicStat.vue?vue&type=style&index=0&id=64f83016&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f83016",
  null
  
)

export default component.exports